var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.stock'),"text":_vm.$t('resalesStocks.description'),"name":"resalesStocks","url":_vm.$listRoutes.resalesStocks,"table":_vm.resalesStocks,"filters":_vm.resalesStocksFilters,"fields":_vm.fields,"display-date":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }